module.exports = __webpack_public_path__ + "img/sz.dc2faeb7.svg";